import { ChangeCompanyComponent } from './../change-company/change-company.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { UserService, AuthenticationService } from '../../_services';
import { Component, OnInit, } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LogoComponent } from '../../_shared/logo/logo.component';
import { PasswordInputComponent } from '../../_shared/password-input/password-input.component';
import { PasswordStrengthChecklistComponent } from '../../_shared/password-strength-checklist/password-strength-checklist.component';
import { getPasswordStrengthFlags, passwordStrengthValidator } from '../../_shared/validators/password-strength.validator';


@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, LogoComponent, PasswordInputComponent, PasswordStrengthChecklistComponent],
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  formChangePassword: FormGroup | any;
  isEqualPassword = true;
  constructor(
    private router: Router,
    private userService: UserService,
    private authService: AuthenticationService,
    private modalService: BsModalService,
    public translate: TranslateService,
  ) { }

  ngOnInit() {
    document.body.className = 'hold-transition login-page';
    this.formChangePassword = new FormGroup({
      password: new FormControl('', [Validators.required, passwordStrengthValidator()]),
      passwordConfirm: new FormControl('', [Validators.required, passwordStrengthValidator()]),
    });

    this.formControlValueChanged();
  }

  get passwordFlags() {
    return getPasswordStrengthFlags(this.formChangePassword?.controls?.password?.value);
  }
  change() {
    const initialState = {
      title: 'Validar',
    };
    this.modalService.show(ChangeCompanyComponent, { initialState, class: 'modal-lg' });
  }

  saveChange() {
    // console.log("chamar funçaõ de alteração")
    const data = JSON.parse(localStorage.getItem("newUser") || '""')
    this.userService.resetPassword(data, data.password, this.formChangePassword.controls.password.value).subscribe((result: any) => {
      this.authService.login(data.username, this.formChangePassword.controls.password.value).subscribe((log: any) => {
        // console.log(log);
        // this.router.navigate(['/dashboard'])
        const currentUser = this.authService.currentUserValue;
        this.change();
        this.userService.updateMongo(currentUser).subscribe((data: any) => {
          // console.log(data);
        });
      })
    })


  }

  checkPassWordValues() {
    if(this.formChangePassword.controls.password.value != this.formChangePassword.controls.passwordConfirm.value) {
      this.isEqualPassword = false;
      return false;
    } else {
      this.isEqualPassword = true;
      return true;
    }

  }

  formControlValueChanged() {
    this.formChangePassword.get('passwordConfirm').valueChanges.subscribe(
      (mode: string) => {
        // console.log(mode);
        this.checkPassWordValues();
      });
  }


}
